var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.navComponent,{tag:"component",staticClass:"flex flex-row items-center lg:flex-col justify-between lg:justify-between"})}
var staticRenderFns = []

export { render, staticRenderFns }